// Canonical enum raw values used by iOS & web:
// 'inpatient' | 'emergencyRoom' | 'outpatient' | 'consult'

export const LABELS = ['Inpatient', 'Outpatient', 'Emergency Room', 'Consult', 'All'];

export const toEnum = (labelOrStored) => {
  const t = String(labelOrStored || '').trim().toLowerCase();
  if (t.startsWith('inpatient') || t === 'floor') return 'inpatient';
  if (t === 'ed' || t.startsWith('emergency')) return 'emergencyRoom';
  if (t.startsWith('out')) return 'outpatient';
  if (t.startsWith('consult')) return 'consult';
  if (t === 'all') return 'All';
  return 'inpatient';
};

export const toLabel = (enumVal) => {
  switch (enumVal) {
    case 'inpatient': return 'Inpatient';
    case 'emergencyRoom': return 'Emergency Room';
    case 'outpatient': return 'Outpatient';
    case 'consult': return 'Consult';
    default: return 'Inpatient';
  }
};
